

import { MenuItem } from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import KycApproveDialog from '../../dialogs/KycApproveDialog';
import i18n from '../../../i18n';

export default class WalletUsersPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'wallet-users';
        this.Server = this.props.context.getState().server.walletUsers;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'email', 'phone', 'firstName', 'lastName'];

        const defaultHead = [
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'email',
                label: 'email',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'phone',
                label: 'phone',
                alignRight: false,
                cell: 'Phone',
                displayGrid: true
            },
            {
                id: 'firstName',
                label: 'firstName',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'lastName',
                label: 'lastName',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'middleName',
                label: 'middleName',
                alignRight: false,
                cell: 'Text',
                displayGrid: false
            },
            {
                id: 'dateOfBirth',
                label: 'dateOfBirth',
                alignRight: false,
                cell: 'Date',
                displayGrid: false
            },
            {
                id: 'gender',
                label: 'gender',
                alignRight: false,
                cell: 'Items',
                items: ['male', 'female', 'other'],
                displayGrid: false
            },
            {
                id: 'countryId',
                label: 'country',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'publicCountries',
                object: 'country',
                show: 'name'
            },
            {
                id: 'city',
                label: 'city',
                alignRight: false,
                cell: 'Text',
                displayGrid: false
            },
            {
                id: 'postCode',
                label: 'postCode',
                alignRight: false,
                cell: 'Text',
                displayGrid: false
            },
            {
                id: 'address',
                label: 'address',
                alignRight: false,
                cell: 'BigText',
                displayGrid: false
            },
            {
                id: 'notificationSettingsJson',
                label: 'notificationSettings',
                alignRight: false,
                cell: 'Json',
                displayGrid: true,
                // displayDialogDetails: true,
                // details: 'Json'
            },
            {
                id: 'language',
                label: 'language',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'isActive',
                label: 'isActive',
                alignRight: false,
                cell: 'Enable',
                displayGrid: true
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head,
            kycApproveDialogOpen: false,
            kycApproveUser: null
        };
    }

    openKycApproveDialog = () => {
        const user = this.getMenuClickItem();
        this.handleCloseMenu();
        this.setState({
            kycApproveDialogOpen: true,
            kycApproveUser: user || null
        });
    };

    handleKycApproveDialogClose = (success) => {
        this.setState({
            kycApproveDialogOpen: false,
            kycApproveUser: null
        });
        if (success) {
            this.retrieveData();
        }
    };

    renderCustomMenuItems(id) {
        const user = this.List.find((item) => item.id === id);
        if (!user || user.kycApproved) {
            return null;
        }
        return (
            <MenuItem onClick={this.openKycApproveDialog}>
                <VerifiedUserIcon sx={{ mr: 2 }} />
                {i18n.t('buttons.kycApprove')}
            </MenuItem>
        );
    }

    renderCustom() {
        return (
            <KycApproveDialog
                open={this.state.kycApproveDialogOpen}
                user={this.state.kycApproveUser}
                onClose={this.handleKycApproveDialogClose}
            />
        );
    }
}
